import script from "./button.vue?vue&type=script&setup=true&lang=ts"
export * from "./button.vue?vue&type=script&setup=true&lang=ts"

import "./button.vue?vue&type=style&index=0&id=5cb2ac70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb2ac70"]])

export default __exports__